import { useEffect, useState } from "react";
import { Logo } from "./Buttons";

const LINKS = [
    { href: "#servizi", label: "Servizi" },
    { href: "#lavori", label: "Lavori" },
    { href: "#azienda", label: "Azienda" },
    { href: "#contatti", label: "Contatti" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-bitume/80 backdrop-blur-xl border-b border-white/5"
                    : "bg-transparent"
            }`}
            data-testid="site-nav"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
                <Logo />
                <nav className="hidden md:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.href.slice(1)}`}
                            className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-ash transition-colors duration-300 hover:text-cloud"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <a
                    href="#contatti"
                    data-testid="nav-cta-preventivo"
                    className="bg-ambra text-bitume font-display font-bold text-sm px-5 py-2.5 frame-clipped-sm transition-all duration-300 hover:brightness-110"
                >
                    Preventivo
                </a>
            </div>
        </header>
    );
}
